import React, { PropsWithChildren, useEffect, useMemo, useState } from 'react';
import { useFormaliteService } from '@europrocurement/l2d-domain';
import {
    ValideursDesDossiersDossierValidatorResponseDtoJsonldValidatorsDossierRead as DossierValidator,
    ProcDureDeValidationDesDossiersJsonldDossierValideursStatusRead as DossierValidatorStatus,
} from '@europrocurement/l2d-domain/openApi/ApiFormalite';
import DossierValidatorContext from './DossierValidatorContext';

const DossierValidatorProvider: React.FunctionComponent<PropsWithChildren> = function ({
    children,
}) {
    const [validators, setValidators] = useState<Array<DossierValidator>>([]);
    const [validatorsStatus, setValidatorsStatus] = useState<Array<DossierValidatorStatus>>([]);
    const contextValue = useMemo(
        () => ({ validators, setValidators, validatorsStatus, setValidatorsStatus }),
        [validators, setValidators, validatorsStatus, setValidatorsStatus],
    );
    const { validatorsApi, validationProcessApi } = useFormaliteService();

    useEffect(() => {
        validationProcessApi
            .apiValideursStatusGetCollection({ itemsPerPage: 999 })
            .then((response) => setValidatorsStatus(response.data['hydra:member']));
        validatorsApi
            .apiDossiersValideursGetCollection()
            .then((response) => setValidators(response.data['hydra:member']));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <DossierValidatorContext.Provider value={contextValue}>
            {children}
        </DossierValidatorContext.Provider>
    );
};

export default DossierValidatorProvider;
